import * as React from 'react';
import * as shortid from 'shortid';
import {styled} from '../../utils';
import {SvgIconProps} from './types';

const Root = styled('svg')<SvgIconProps>(({size, theme}) => ({
  fontSize: theme.fontSize.base,
  fill: 'currentColor',
  height: size || 24,
  width: size || 24
}));

// TODO: add docs and tests
export default class SvgIcon extends React.Component<SvgIconProps, {}> {
  private _titleId = shortid.generate();

  public render() {
    const {title, children, ...restProps} = this.props;
    const titleId = this._titleId;

    const rootProps = {
      'aria-hidden': title ? null : true,
      'aria-labelledby': title && titleId,
      focusable: 'false',
      role: 'img',
      viewBox: '0 0 24 24',
      ...restProps
    };

    return (
      <Root {...rootProps}>
        {title ? <title id={titleId}>{title}</title> : null}
        {children}
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SvgIcon/SvgIcon.tsx